export const style = `
.topbar-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  vertical-align: text-bottom;
  user-select: none;
}
.topbar-icon > * {
  max-width: 100%;
  height: auto;
}
.icon-close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  color: #737373;
  z-index: 2;
}
`

export const overrideTopbarModalStyles = `
.topbar-modal-content {
    display: flex;
    flex-direction: column;
  }
`
